import { Body } from "@sprout/typography.tsx";
import FileIcon from "@sprout/file_icon.tsx";
import type { ProfileData } from "@/queries/use_profile.ts";

type Props = {
  data: ProfileData;
};

const ResumeBody = ({ data }: Props) => {
  const resume = data.resume;

  if (!resume?.filename) return null;

  return (
    <div className="flex items-center gap-2 [&>svg>path]:fill-dark-green">
      <FileIcon contentType={resume.content_type} />
      <a
        href={resume.url}
        target="_blank"
        rel="noopener noreferrer"
        className="min-w-0 no-underline"
      >
        <Body as="span">{resume.filename}</Body>
      </a>
    </div>
  );
};

export default ResumeBody;
